<template>
  <div class="body-common">
    <div class="bg-ylyk">
      <div class="txt-center">
        <div>
          <img
            style="width: 120px; height: 120px; margin: 30px 0 -20px"
            src="../../../../assets/images/sate_right.png"
          />
          <h1 class="font18 color-green">支付成功</h1>
        </div>
      </div>
      <div class="m30 pd30 border-radius8 bg-white txt-center boxshadow">
        <div class="media media-updown">
          <div class="media-body">
            <div class="media-heading font18">长按扫描添加老师微信</div>
            <p class="mtb16 font14">
              <font class="color-orange">完成报名</font>
              <font>才能观看课程</font>
            </p>
          </div>
          <div class="media-object fullwidth">
            <img style="width: 70%" :src="adviserInfo.adviserCode" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { mapGetters } from 'vuex'
import service from '@/api/modules/payment/album'
export default {
  data() {
    return {
      adviserInfo: {}
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  methods: {
    getAdviserInfo() {
      service
        .getUnlockOrderStatus({ prePayId: this.$route.query.prePayId, shareCode: this.shareCode })
        .then(data => {
          this.adviserInfo = data
        })
        .finally(res => {})
    }
  },
  created() {
    if (this.$route.query.prePayId) {
      this.getAdviserInfo()
    }
  },
  mounted() {}
}
</script>

<style lang="scss"></style>
